module.exports = __webpack_public_path__ + "img/Logo UJED horizontal.7c158473.png";